export default {"src":"/_next/static/media/LightCircleQuestion.6c5f35e9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};